"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuexClass = require("vuex-class");

var _vuePropertyDecorator = require("vue-property-decorator");

var _request = require("@/services/request/request.service");

var _helper = require("@/mixins/helper/helper");

var _logger = require("@/mixins/logger/logger");

var _theme = require("@/mixins/theme/theme");

var _elementUi = require("element-ui");

var _fullscreen = _interopRequireDefault(require("@/components/fullscreen/fullscreen.vue"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var NavbarComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(NavbarComponent, _Mixins);

  var _super = _createSuper(NavbarComponent);

  function NavbarComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, NavbarComponent);
    _this = _super.apply(this, arguments);
    _this.companyName = process.env.VUE_APP_NAME;
    _this.isNavBarColored = false;
    _this.isNavBarTransparent = true;
    _this.cookieKey = 'planning-theme';
    _this.isShowLang = false;
    _this.isShowUser = false;
    return _this;
  }

  (0, _createClass2.default)(NavbarComponent, [{
    key: "themeChanges",
    value: function themeChanges(newVal) {
      newVal ? this.helper.toggleTheme(document.body, 'dark-theme') : this.helper.toggleTheme(document.body, 'light-theme');
      this.setTheme(newVal);
    }
  }, {
    key: "$anyChanges",
    get: function get() {
      return this.$store.getters['lastMileDelivery/anyChanges'] || this.$store.getters['lastMileDeliveryPricerite/anyChanges'] || this.$store.getters['lastMileDeliveryWellcome/anyChanges'] || this.$store.getters['lastMileV2/anyChanges'] || this.$store.getters['milkRun/anyChanges'];
    }
  }, {
    key: "$isAssignedDriverChanges",
    get: function get() {
      return this.$store.getters['lastMileDelivery/isAssignedDriverChanges'] || this.$store.getters['lastMileDeliveryPricerite/isAssignedDriverChanges'] || this.$store.getters['lastMileDeliveryWellcome/isAssignedDriverChanges'] || this.$store.getters['lastMileV2/isAssignedDriverChanges'] || this.$store.getters['milkRun/isAssignedDriverChanges'];
    }
  }, {
    key: "homeRoute",
    get: function get() {
      return this.$isAdmin ? '/admin-dashboard' : '/dashboard';
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('beforeunload', this.handleClose);
    }
  }, {
    key: "beforeCreate",
    value: function beforeCreate() {
      if (!this.request) {
        this.request = new _request.Request('application/json');
      }
    }
  }, {
    key: "created",
    value: function created() {
      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('beforeunload', this.handleClose);

      if (window.localStorage.getItem('isLoggedIn') && !window.localStorage.getItem('hasNoAccess')) {
        window.localStorage.removeItem('isLoggedIn');
      }
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var theme = this.getTheme();
      this.$isDarkTheme = !(theme === undefined || theme === null || theme === false);
    }
  }, {
    key: "handleScroll",
    value: function handleScroll() {
      if (this.helper.get(document, 'documentElement.scrollTop') >= 10 || this.helper.get(document, 'body.scrollTop') >= 10) {
        this.isNavBarColored = true;
        this.isNavBarTransparent = false;
      } else {
        this.isNavBarColored = false;
        this.isNavBarTransparent = true;
      }
    }
  }, {
    key: "updateSidebar",
    value: function updateSidebar() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.$emit('onUpdateSidebar', value);
    }
  }, {
    key: "setLang",
    value: function setLang(langCode) {
      if (langCode !== this.$i18n.locale) {
        var messsages = this.$i18n.getLocaleMessage(langCode);

        if (Object.keys(messsages).length === 0) {
          this.$i18n.setLocaleMessage(langCode, require("../../translations/".concat(langCode, ".json")));
        }

        this.$i18n.locale = langCode;
        this.$changeLanguage(langCode);
      }
    }
  }, {
    key: "logOutUser",
    value: function logOutUser() {
      if (this.$anyChanges) {
        var permission = this.$route.meta.permission;

        if (permission.includes('lastMileDelivery')) {
          this.$resetLMDPlan();
        }

        if (permission.includes('milkRun')) {
          this.$resetMRPlan();
        }
      }

      window.localStorage.setItem('isLoggedOut', '1');
      window.localStorage.setItem('rld', '1');

      if (!this.$isAdmin) {
        window.localStorage.setItem('rQuery', this.helper.encode(this.$route.fullPath.substring(1)));
      }

      this.$logOutUser();
      this.$router.push({
        path: '/'
      });
    }
  }, {
    key: "getTheme",
    value: function getTheme() {
      var token = this.helper.getCookie(this.cookieKey);

      if (token) {
        try {
          return JSON.parse(token);
        } catch (err) {
          return undefined;
        }
      }

      return token;
    }
  }, {
    key: "setTheme",
    value: function setTheme(theme) {
      return this.helper.setCookie(this.cookieKey, theme);
    }
  }, {
    key: "refreshBrowser",
    value: function refreshBrowser() {
      location.reload();
    }
  }, {
    key: "toggleFullscreen",
    value: function toggleFullscreen() {
      var el = this.helper.get(this.$refs, 'fullscreen', null);

      if (el) {
        el.toggleFullscreen();
      }
    }
  }, {
    key: "handleClose",
    value: function handleClose(e) {
      if (this.$anyChanges) {
        e.preventDefault();
        e.returnValue = this.$i18n.t('general.stillSomeChanges');
      }
    }
  }]);
  return NavbarComponent;
}((0, _vuePropertyDecorator.Mixins)(_helper.HelperMixin, _logger.LoggerMixin, _theme.ThemeMixin));

(0, _tslib.__decorate)([(0, _vuexClass.Getter)('isTab', {
  namespace: 'common'
})], NavbarComponent.prototype, "$isTab", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('isFullscreen', {
  namespace: 'common'
})], NavbarComponent.prototype, "$isFullscreen", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('isAdmin', {
  namespace: 'authentication'
})], NavbarComponent.prototype, "$isAdmin", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('isLogIn', {
  namespace: 'authentication'
})], NavbarComponent.prototype, "$isLogIn", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userInformation', {
  namespace: 'authentication'
})], NavbarComponent.prototype, "$userInformation", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userData', {
  namespace: 'authentication'
})], NavbarComponent.prototype, "$userData", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('changeLanguage', {
  namespace: 'common'
})], NavbarComponent.prototype, "$changeLanguage", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('logOutUser', {
  namespace: 'authentication'
})], NavbarComponent.prototype, "$logOutUser", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('resetPlan', {
  namespace: 'lastMileDelivery'
})], NavbarComponent.prototype, "$resetLMDPlan", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('resetPlan', {
  namespace: 'milkRun'
})], NavbarComponent.prototype, "$resetMRPlan", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: false
})], NavbarComponent.prototype, "isShowSidebar", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$isDarkTheme')], NavbarComponent.prototype, "themeChanges", null);
NavbarComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'NavbarComponent',
  components: {
    'el-tooltip': _elementUi.Tooltip,
    'el-dropdown': _elementUi.Dropdown,
    'el-dropdown-menu': _elementUi.DropdownMenu,
    'el-dropdown-item': _elementUi.DropdownItem,
    'el-switch': _elementUi.Switch,
    'el-header': _elementUi.Header,
    'fullscreen': _fullscreen.default
  }
})], NavbarComponent);
var _default = NavbarComponent;
exports.default = _default;